export default __webpack_public_path__ + "80115d2deaf94bb7d0114ca264448523.wav";